import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useMemo } from 'react';
import { fetchRunningTimers } from '../redux/Slices/timerSlice';

const defaultTimerState = {
    mode: 'stopwatch',
    timeLeft: 0,
    isRunning: false,
    totalTime: 0,
    timerStatus: 'idle',
    startTime: null,
    stopwatchElapsed: 0,       // ✅ Ensure this is present
    countdownElapsed: 0,       // ✅ Ensure this is present
    elapsedOffset: 0,
    title: null,
    error: null,
    hydrated: false,
};

// --- useTimer Hook ---
export const useTimer = (cardId) => {
    const rawTimer = useSelector((state) => state.timer.timers[cardId]);
    const loading = useSelector((state) => state.timer.loading);
    const timer = rawTimer ?? defaultTimerState;

    return { ...timer, loading, hydrated: rawTimer?.hydrated || false };
};

// --- useRunningTimers Hook ---
export const useRunningTimers = () => {
    const timers = useSelector((state) => state.timer.timers);

    const runningTimers = useMemo(
        () =>
            Object.entries(timers)
                .filter(([_, timer]) => timer.timerStatus === 'running' || timer.timerStatus === 'paused')
                .map(([cardId, timer]) => ({ cardId, ...timer })),
        [timers]
    );

    return runningTimers;
};

// --- useTimerManager Hook ---
export const useTimerManager = () => {
    return useSelector((state) => state.timer.timerManager);
};

// --- useTimerSync Hook ---
export const useTimerSync = (intervalMs = 30000) => {
    const dispatch = useDispatch();
    const runningTimers = useRunningTimers();

    useEffect(() => {
        dispatch(fetchRunningTimers()); // Initial fetch

        const interval = setInterval(() => {
            if (runningTimers.length > 0) {
                dispatch(fetchRunningTimers());
            }
        }, intervalMs);

        return () => clearInterval(interval);
    }, [dispatch, intervalMs]);
};
